import { createSlice } from "@reduxjs/toolkit";

import {
  deleteFinancing,
  addFinancing,
  updateFinancing,
  getFinancing,
} from "./thunk";

interface FinancingStateType {
  financing: Array<any>;
  error?: string | object | null | undefined | unknown;
  success?: string | object | null | undefined | unknown;
}

export const initialState: FinancingStateType = {
  financing: [],
  error: null,
  success: null,
};

const financingSlice = createSlice({
  name: "financing",
  initialState,
  reducers: {
    financingError(state, action) {
      state.error = action.payload;
    },
    financingSuccess(state, action) {
      state.success = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(getFinancing.fulfilled, (state: any, action: any) => {
      state.financing = action.payload;
    });
    builder.addCase(getFinancing.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(addFinancing.fulfilled, (state: any, action: any) => {
      state.financing.push(action.payload);
    });
    builder.addCase(addFinancing.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(updateFinancing.fulfilled, (state: any, action: any) => {
      state.financing = state.financing.map((financing: any) =>
        financing.id === action.payload.id
          ? { ...financing, ...action.payload }
          : financing
      );
    });
    builder.addCase(updateFinancing.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(deleteFinancing.fulfilled, (state: any, action: any) => {
      state.financing = state.financing.filter(
        (financing: any) => financing.id !== action.payload
      );
    });
    builder.addCase(deleteFinancing.rejected, (state, action) => {
      state.error = action.payload || null;
    });
  },
});

export const { financingError, financingSuccess } = financingSlice.actions;

export default financingSlice.reducer;
